import { AlertTriangle, X } from "lucide-react";

export interface ConflictToastState {
  componentId: string;
  editedByName: string;
  description: string;
}

export function ConflictToast({
  conflict,
  onDismiss,
}: {
  conflict: ConflictToastState | null;
  onDismiss: () => void;
}) {
  if (!conflict) {
    return null;
  }

  return (
    <div className="pointer-events-auto flex items-start gap-3 rounded-2xl border border-amber-500/20 bg-amber-500/10 px-4 py-3 text-sm text-amber-900 shadow-lg dark:text-amber-100">
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
      <div className="min-w-0 flex-1">
        <div className="font-medium">Concurrent edit detected</div>
        <div className="mt-1 text-xs leading-5">
          {conflict.editedByName} also changed <span className="font-medium">{conflict.componentId}</span>.
          {" "}
          {conflict.description}
        </div>
      </div>
      <button
        type="button"
        onClick={onDismiss}
        className="rounded-md p-1 text-amber-900/70 transition hover:bg-amber-500/15 hover:text-amber-950 dark:text-amber-100/70 dark:hover:text-white"
        aria-label="Dismiss collaboration conflict"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
